<script setup lang="ts">
import type { Component } from "@vue/runtime-core";

const props = defineProps<{
    icon: Component;
    title: string;
    notifications?: number;
    active?: boolean;
    showTitle?: boolean;
    information?: string;
}>();
</script>

<template>
    <div class="cursor-pointer">
        <div class="group xs:mb-0 md:mb-4 xl:mb-6 flex items-center flex-col">
            <button
                :aria-label="
                props.notifications
                  ? props.title + ' ' + props.notifications + ' novas notificações'
                  : props.title
                "
                :title="props.information || props.title"
                class="relative focus:outline-none cursor-pointer"
            >
                <!--icon-->
                <component
                    :is="props.icon"
                    :class="
                      (props.active as boolean)
                        ? ['text-brand-300', 'dark:text-white']
                        : [' text-gray-300']
                    "
                    class="w-8 h-7 group-focus:text-brand-300 group-hover:text-brand-400 active:text-brand-300 active:scale-110 dark:text-gray-500 transition ease-out duration-200"
                />

                <!--notification pill-->
                <div
                    v-if="props.notifications"
                    class="absolute right-0 top-0 w-5 h-5 flex items-center justify-center outline-none bg-brand-300 dark:bg-brand-400 text-xs text-white border border-white dark:border-gray-800 rounded-full transition duration-500"
                >
                    {{ props.notifications }}
                </div>
            </button>
            <p v-if="showTitle" class="m-0 text-xs color-brand-500 text-gray-700 text-center dark:text-gray-200 max-w-[80px] truncate inline-block md:max-w-[200px] md:whitespace-normal">{{ props.title }}</p>
        </div>
    </div>
</template>


<style scoped>

</style>